export const ANTIVIRUS = "Antivirus license";
export const CERTIFICATE = "Web certificate";
export const CONNECT24 = "Connect24 certificate";
export const LOG_FORWARDING = "Log forwarding certificate";
export const NEO_XMLS = "NEO XMLs";
export const ICONS = "Icon";
export const EMAIL_TEMPLATES = "Email templates";
export const EVENTS = "Events";
export const APP_CUSTOMIZATION = "App Customizations";
export const DEFAULT_CUSTOMIZATION = "Default Customizations";
export const PMAX_XMLS = "PMAX XMLs";
export const IQ_CONFIGURATION = "IQ configuration";
export const IQ_CONFIG_SCHEMA = "IQ configuration schema";
export const IQ_PATCH_TAGS = "IQ patch tags";
